import * as React from 'react';
import { Pill } from '@teamsnap/teamsnap-ui';

interface Waiver {
  id: number;
  title: string;
  content: string;
  active: boolean;
}

const styles = {
    height: '71px',
    display: 'block',
    padding: '4px 8px',
    justifyContent: 'center',
    marginBottom: '24px',
    backgroundColor: '#f2f2f2'
}

export const NgbWaiverPill: React.FC<Props> = ({
    children
}) => 
      <Pill
          testId="add-waiver-button"
          style={styles}
      >
                <div className="u-flex sui-items-center">
                    <figure className="sui-h-[24px] sui-w-[26px]">
                        <img
                            src={'/images/hockey-canada-logo.png'}
                            alt="Logo"
                            className="sui-w-full sui-h-full"
                        />
                    </figure>
                    <h4 className="sui-ml-1" data-testid={'hc-waiver-title'}>
                        Hockey Canada Waivers
                    </h4>
                </div>
                <div>
                    <p className="sui-h-full sui-text-desktop-2">
                    Hockey Canada critical waivers will be assigned to each participant during registration since verification of Hockey Canada registration numbers is enabled.
                    </p>
                </div>
      </Pill>

export default NgbWaiverPill;